var QGIV = QGIV || {};

/**
 * FeeCoverage
 * Methods to calculate fees for GiftAsist
 */
QGIV.FeeCoverage = {
	label : 'Covered Costs',

	/**
	 * Calculates fee based on GiftAssist type
	 * @param  {number} amount Amount to apply fee to
	 * @param  {int}    type   Numeric representation of fee type
	 * @param  {number} value  Fee value
	 * @return {number} fee    Fee amount
	 */
	round : function(amount){
		var value = amount.toString().split('.');

		var num = ((value[0] == undefined || (value[0].length < 1)) ? 0 : parseInt(value[0])),
			decimal = ((value[1] == undefined || value[1].length < 1) ? '0000' : value[1]);

		var tenths = parseInt(decimal[0]),
			hundredths = parseInt( ((decimal[1] == undefined) ? '0' : decimal[1]) ),
			thousandths = parseInt( ((decimal[2] == undefined) ? '0' : decimal[2]) ),
			tenThousandths = parseInt( ((decimal[3] == undefined) ? '0' : decimal[3]) );

		if (thousandths > 5 || (thousandths == 5 && tenThousandths > 0)) {
			// round up
			if (hundredths == 9) {
				hundredths = 0;

				if (tenths == 9) {
					tenths = 0;
					num += 1;
				} else {
					tenths += 1;
				}
			} else {
				hundredths += 1;
			}
		}

		var rounded = parseFloat(num.toString() + '.' + tenths.toString() + hundredths.toString()).toFixed(2);

		return rounded;
	},

	/**
	 * Calculates fee based on GiftAssist type
	 * @param  {number} amount Amount to apply fee to
	 * @param  {int}    type   Numeric representation of fee type
	 * @param  {number} value  Fee value
	 * @return {number} fee    Fee amount
	 */
	calculateFee : function(amount, type, value){
		var fee = 0.00,
			amount = amount || 0.00;

		if ( typeof amount == 'string' ){
            amount = amount.replace(/\,/g, '');
        }

        amount = parseFloat(amount);

		// this is a flat fee, no calculations necessary
		if ( type == 2 ){
			value = parseFloat(value);
			return value.toFixed(2);
		}
		// we have a percentage based fee, calculate based on amount (if it's greater than 0) using universal algorithm
		else if ( type == 1 && amount > 0 ){
			fee = amount * (value/100);
		}

		fee = this.round(fee);

		return fee;
	},

	/**
	 * Calculates fee based on GiftAssist type and adds it to the original amount
	 * @param  {number} amount Amount to apply fee to
	 * @param  {int}    type   Numeric representation of fee type
	 * @param  {number} value  Fee value
	 * @return {number}        Fee amount plus original amount
	 */
	calculateTotalWithFee : function(amount, type, value){
		var amount = amount || 0.00;

		if ( typeof amount == 'string' ){
            amount = amount.replace(/\,/g, '');
        }

        amount = parseFloat(amount);

		var fee = parseFloat(QGIV.FeeCoverage.calculateFee(amount, type, value)),
			total = amount + fee;

		total = total.toFixed(2);

		return total;
	}
};


/**
 * PayPal
 * Initialize working with a PayPal session
 */
QGIV.PayPal = {
	// storage for PayPal window
	window : null,

	// our PayPal window path
	path : '',

	// defining our container scope
	$container : $ ? $(document) : null, // NOTE: Sentry fix for jQuery not always being present when this script is loaded.

	// flag to make sure we should open PayPal window
	validated : true,

	// store the amount that has been authorized with PayPal
	authorizedAmount : 0,

	// callback function for validation purposes
	onBeforeOpen : function($button){},

	// supported flag
	supported : true,

	// gentlemen, start your engines
	init : function(){
		var _this = this;

		// check to see if PayPal is supported, show support message
		// postMessage to popup windows from non-Qgiv domains is not supported in IE 11
		if (!!navigator.userAgent.match(/Trident.*rv\:11\./) && typeof(QGIV.Form) !== "undefined" && QGIV.Form.isWidget ) {
			_this.supported = false;

			$('.js-authenticate-paypal-container')
				.find('.js-paypal-status-unsupported').removeClass('hide-content')
				.end()
				.find('.js-paypal-status-container').addClass('hide-content');
		}

		if ( _this.supported ) {
			// bind logic for "Pay Using PayPal" button
			$('.js-authenticate-paypal').on('click', function(e){
				// setting our initial path to be the href of the button
	            _this.path = $(this).attr('href');

	            // set the container
	            _this.$container = $(this).closest('.js-authenticate-paypal-container');

	            // run a callback function for validation
	            _this.onBeforeOpen.call(_this, $(this));

	            // if we have everything we need,
	            // open the PayPal window with our formatted path and focus on it
	            if ( _this.validated ) {
		            _this.window = window.open(_this.path, 'paypalWindow', 'width=600,height=600,resizable=yes,menubar=no,location=no');
		            _this.window.focus();
		        }

	            e.preventDefault();
	        });

			// bind postMessage event listener for PayPal authentication window
	        window.addEventListener('message', function(e){
	            // double check that our message comes from our domain
	            if ( e.origin !== QGIV.Environment ) return;

	            // convert message to JSON object
	            var response = QGIV.Utilities.parseJSON(e.data);

	            if ( ! response ) return;

	            // since PostMessage is used in various places throughout the system, we should make sure we only respond if it's a PayPal message
	            if ( response.event == 'paypal' ) {
		            // replace the PayPal hidden input values
		            $.each(response, function(i, v){
		                _this.$container?.find('.js-paypal-' + i).val(v);
		            });

		            // update UI showing we have the PayPal data that we need
		            _this.$container?.find('.js-paypal-status-unauthenticated').addClass('hide-content');
		            _this.$container?.find('.js-paypal-status-authenticated').fadeIn(500);

		            // close PayPal window
		            if ( _this.window ) _this.window.close();
		        }
	        }, false);
	    }
	},

	// validates an amount against the currently authorized PayPal amount
	validateAuthorizedAmount : function(amount){
		// check if we have a different amount than what was authorized
		if ( amount && amount > 0 && this.authorizedAmount > 0 && amount !== this.authorizedAmount ) {
			this.resetAuthentication();
		}
	},

	// resets the paypal fields and prompt to authenticate with PayPal
	resetAuthentication : function(){
		// remove the value of the PayPal tokens
		this.$container?.find('.js-paypal-token, .js-paypal-payerID').val('');

		// reset the UI
		this.$container?.find('.js-paypal-status-authenticated').addClass('hide-content').removeAttr('style');
		this.$container?.find('.js-paypal-status-unauthenticated').removeClass('hide-content');
	}
}


/**
 * ApplePay
 * Initialize working with an ApplePay session
 */
QGIV.PaymentRequest = {
    currencyCode : 'USD',
    countryCode : 'US',
    requiredBillingContactFields : ['postalAddress'],
    requiredShippingContactFields : ['name', 'email'],
    supportedNetworks : (typeof QGIV.Form !== 'undefined' ? QGIV.Form.applePaySupportedNetworks || [] : []),
    merchantCapabilities : ['supportsCredit', 'supportsDebit', 'supports3DS'],
    total : {
        label : 'Total',
        amount : 0.00
    }
};

QGIV.ApplePay = {
	// store the merchant ID
	merchant : (window.location.hostname.indexOf('dev.qgiv.com') !== -1 ? 'merchant.dev.qgiv.com' : 'merchant.secure.qgiv.com'),

	// store the Apple Pay session
	session : null,

	// flag to make sure we should continue with Apple Pay session
	validated : true,

	// flag to check if Apple Pay is supported
	supported : false,

	// store the amount that has been authorized with Apple Pay token
	authorizedAmount : 0,

	// callback function for starting Apple Pay session
	onSessionStart : function(promise){},

	// callback function for validation purposes
	onBeforeOpen : function($button){},

	// callback function for merchant validation
	onValidateMerchant : function(response){},

	// callback function for successful authorization
	onPaymentAuthorized : function(response){},

	// create Apple Pay session and event bindings
	init : function(){
		var _this = this;

        // we are not set up to support Apple Pay on external domains
        // wrapped in a document.ready() to ensure that the logic that
        // potentially sets QGIV.Embed.isWidget to true is run before we check
        // to see if the form is displayed as a widget
        $(document).ready(function(){
            const isWidget = !!QGIV.Embed && !!QGIV.Embed.isWidget;
            if (
                window.ApplePaySession
                && QGIV.PaymentRequest.supportedNetworks.length
                && !isWidget
            ) {
                var promise = ApplePaySession.canMakePaymentsWithActiveCard(_this.merchant);

                promise.then(function(canMakePayments){
                    if ( canMakePayments && $('.js-payment-type-option-apple-pay').length ) {
                        $('.js-apple-pay-button, .js-payment-type-option-apple-pay').removeClass('hide-content');
                        // default payment type to Apple Pay
                        $('.js-payment-type-option').prop('checked', false);
                        $('.js-payment-type-option[value="applepay"]')
                            .prop('checked', true).trigger('change')
                            .closest('.js-tab').trigger('click');
                        _this.supported = true;
                    } else {
                        console.log('QGIV: Apple Pay is not supported.');
                    }

                    _this.onSessionStart.call(_this, canMakePayments);
                });

                $('.js-apple-pay-button').on('click', function(e){
                    // preventing form submission
                    e.preventDefault();

                    // run a callback function for validation and PaymentRequest setup
                    _this.onBeforeOpen.call(_this, $(this));

                    if ( _this.validated ) {
                        // create Apple Pay session
                        _this.session = new ApplePaySession(2, QGIV.PaymentRequest);

                        // merchant validation
                        // ApplePay documentation for expected payload: https://developer.apple.com/reference/applepayjs/applepaysession#2166532
                        // Example PHP file: https://github.com/norfolkmustard/ApplePayJS/blob/master/apple_pay_comm.php
                        _this.session.onvalidatemerchant = function(event){
                            var promise = new Promise(function(resolve, reject){
                                // AJAX call to backend to validate merchant goes here
                                // response should be JSON-encoded
                                $.ajax({
                                    url : '/common/apple_pay_authentication.php?u=' + event.validationURL,
                                    success : function(response){
                                        _this.onValidateMerchant.call(_this, response);
                                        resolve(JSON.parse(response));
                                    }
                                });
                            });

                            promise.then(function(merchantSession){
                                _this.session.completeMerchantValidation(merchantSession);
                            });
                        };

                        // payment method selection
                        _this.session.onpaymentmethodselected = function(event){
                            var total = QGIV.PaymentRequest.total;

                            _this.session.completePaymentMethodSelection(total, [total]);
                        };

                        // payment method authorization
                        _this.session.onpaymentauthorized = function(event){
                            // set the value of the hidden input to the token value
                            $('.js-apple-pay-token').val(JSON.stringify(event.payment));
                            if ($('.js-billing-same-as').prop('checked')) {
                                $('.js-billing-same-as').prop('checked', false);
                                $('#billing-first-name').val(event.payment.billingContact.givenName);
                                $('#billing-last-name').val(event.payment.billingContact.familyName);
                                $('#billing-country').val(event.payment.billingContact.countryCode);
                                $('#billing-city').val(event.payment.billingContact.locality);
                                $('#billing-zip').val(event.payment.billingContact.postalCode);
                                $('#billing-state').val(event.payment.billingContact.administrativeArea);
                                // if setting shorthand didn't work, we'll try setting using the state code data attribute
                                if ( ! $('#billing-state').val() ) $('#billing-state').find('option[data-state-code="' + event.payment.billingContact.administrativeArea + '"]').prop('selected', true).trigger('chosen:updated');
                                $('#billing-address').val(event.payment.billingContact.addressLines[0]);
                            }
                            // run payment authorized callback function
                            _this.onPaymentAuthorized.call(_this, event);

                            // complete payment session
                            // TODO : handle form errors and pass STATUS_FAILURE
                            _this.session.completePayment(ApplePaySession.STATUS_SUCCESS);
                        };

                        // cancel event
                        _this.session.oncancel = function(event){
                            // cancelled payment
                            //_this.session.abort();
                        };

                        // gentlemen, start your engines
                        _this.session.begin();
                    }
                });
            } else {
                console.log('QGIV: Apple Pay is not supported.');
            }
        });
	}
};

QGIV.Payment = {
	// reference for verbose output
	cardTypes : {
		VS : 'visa',
		MC : 'mastercard',
		AM : 'amex',
		DC : 'discover'
	},

	/**
	 * Figures out the credit card type and evaluates it to be a valid credit card number
	 * @param   cardNumber {string}  Card number to validate
	 * @return  {boolean}
	 */
	isValidCard : function(cardNumber){
		var cardType = this.getCardType(cardNumber);

		if ( typeof cardNumber !== 'undefined' && cardType ) {
			var length = cardNumber.length,
				prefix = '';

			if ( cardType == 'VS' ) {
				var ccFirst = cardNumber.charAt(0);

			    if ( ( length != 16 && length != 13 && length != 19 ) || ( ccFirst != 4 ) ) {
					return false;
				}
			} else if ( cardType == 'MC' ) {
				var e_prefix = parseInt(cardNumber.substring(0,4));

				prefix = parseInt(cardNumber.substring(0,2));

				if ( ( (prefix < 51 || prefix > 55) && (e_prefix < 2221 || e_prefix > 2720) ) || (length != 16) ) {
					return false;
				}
			} else if ( cardType == 'AM' ) {
				prefix = parseInt(cardNumber.substring(0,2));

				if ( ( (prefix != 34) && (prefix != 37) ) || (length != 15 && length != 17) ) {
					return false;
				}
			} else if ( cardType == 'DC' ) {
				prefix = parseInt(cardNumber.substring(0,4)),
				firstTwo = parseInt(cardNumber.substring(0, 2));

				if ( ( prefix != 6011 && ( firstTwo < 64 || firstTwo > 65 ) ) || ( length < 16 || length > 19 ) ) {
					return false;
				}
			}

			return this.luhnFormula(cardNumber);
		} else {
		  return false;
		}
	},

	/**
	 * Validates the full credit card type taking into account card number length
	 * @param  cardNumber {string}  Card number to evaluate
	 * @return {string}   Card identifier
	 */
	validateCardType : function(cardNumber){
		var cardNumber = cardNumber || '',
			cardNumberLength = cardNumber.length,
			cardType = '';

		// make sure we have a valid card number first
		if ( ! this.isValidCard(cardNumber) ) return false;

		// it's either visa, mastercard, or discover
		if ( cardNumberLength == 16 || cardNumberLength == 13 || ( cardNumberLength >= 16 && cardNumberLength <= 19 ) ) {
		 	// determining if it's visa, mastercard, or discover
		 	cardType = this.getCardType(cardNumber);
		// it might be american express
		} else if ( cardNumberLength == 15 ) {
		 	cardType = this.getCardType(cardNumber);
		} else {
		 	// it isn't a valid credit card or accepted method of payment
		 	return false;
		}

		// make sure we have a card to return
		if ( cardType ) {
			return cardType;
		} else {
			return false;
		}
	},

	/**
	 * Figures out the credit card type based on first characters
	 * @param  cardNumber {string}  Card number to evaluate
	 * @param  verbose    {string}  Option to output full card name
	 * @return {string}   Card identifier
	 */
	getCardType : function(cardNumber, verbose) {
		var cardNumber = cardNumber || '',
			verbose = verbose || false,
			cardNumberLength = cardNumber.length,
			firstTwo = cardNumber.substring(0, 2),
			firstFour = cardNumber.substring(0, 4),
			cardType = '';

		// it's a visa credit card
		if ( cardNumber.charAt(0) == '4' ) {
			cardType = 'VS';
		}
		// it's an american express credit card
		else if ( parseInt(firstTwo) == 34 || parseInt(firstTwo) == 37 ) {
			cardType = 'AM';
		}
		// it's a mastercard credit card
		else if ( ( parseInt(firstTwo) > 50 && parseInt(firstTwo) < 56 ) || ( parseInt(firstFour) >= 2221 && parseInt(firstFour) <= 2720 ) ) {
			cardType = 'MC';
		}
		// it's a discover credit card
		else if ( parseInt(firstFour) == 6011 || ( parseInt(firstTwo) >= 64 && parseInt(firstTwo) <= 65 ) ) {
			cardType = 'DC';
		}
		// it isn't a valid credit card or accepted method of payment
		else {
			return false;
		}

		// make sure we have a card to return
		if ( cardType ) {
			// return the full string if we're trying to get the verbose output
			if ( verbose && typeof this.cardTypes[cardType] !== 'undefined' ) {
				return this.cardTypes[cardType];
			} else {
				return cardType;
			}
		} else {
			return false;
		}
	},

	/**
	 * Evaluates card validity using the Luhn formula
	 * @param   cardNumber {string} The card number to evaluate
	 * @return  {boolean}
	 */
	luhnFormula : function(cardNumber) {
		var length = cardNumber.length,
			start = (length - 2 ),
			total = 0;

		for( var i = start; i >= 0; i -= 2 ) {
			var num = cardNumber.charAt(i) * 2;

			if ( num > 9 ) {
				var numString = num.toString(),
					nm1 = numString.charAt(0) * 1,
					nm2 = numString.charAt(1) * 1;

				num = nm1 + nm2;
			}

			total += num;
		}

		for ( i = ( start + 1 ); i >= 0; i -= 2 ) {
			var digVal = cardNumber.charAt(i) * 1;
			total += digVal;
		}

		return ((total % 10) == 0);
	},

	/**
	 * Quick unit test for card numbers
	 */
	test : function(){
		// fake, public test numbers
		var cards = ['378282246310005', '371449635398431', '378734493671000', '5610591081018250', '30569309025904', '38520000023237', '6011111111111117', '6011000990139424', '3530111333300000', '3566002020360505', '5555555555554444', '5105105105105100', '4111111111111111', '4012888888881881', '4222222222222', '76009244561', '5019717010103742', '6331101999990016', '6011000990139424', '6011111111111117', '60110009901394246011', '601111111117', '6445644564456445'];

		for ( i = 0; i < cards.length; i++ ) {
			var card = cards[i],
				valid = this.isValidCard(card);

			if ( valid && this.validateCardType(card) ) {
				console.log(this.getCardType(card, true) + ': ' + card);
			} else {
				console.log('Invalid card: ' + card);
			}
		}
	}
}

/*
 * DEPRECATED: Use new QGIV.Payment object instead
 * PaymentFunctions is a javascript class to handle CreditCard validation functions.
 * PaymentFUnctions class constructor takes card number as parameter and initializes the local CardNumber variable.
 */
function PaymentFunctions(number){
	if (this.verifyParameterType(number)) {
		this.cardNumber = (number.length) ? number : "";
	} else {
	  	console.log('invalid card number');
	}
	this.cardType = '';
}

/*
 * Verifies if the given parameter is null or not
 */
PaymentFunctions.prototype.verifyParameterType = function (param) {
	if(typeof(param) == undefined) {
		return false;
	} else {
		return true;
	}
}

/*
 * Verifies a credit card number
 */
PaymentFunctions.prototype.verifyCC = function() {
	if (this.verifyParameterType(this.cardNumber)) {
		var len = this.cardNumber.length;
		var prefix = "";
		if (this.cardType == "VS") {
			var ccFirst = this.cardNumber.charAt(0);
		    if (((len != 16) && (len != 13)) || (ccFirst != 4)) {
				return false;
			}
		} else if (this.cardType == "MC") {
			prefix = parseInt(this.cardNumber.substring(0,2));
			var e_prefix = parseInt(this.cardNumber.substring(0,4));
			if (((prefix < 51 || prefix > 55) && (e_prefix < 2221 || e_prefix > 2720)) || (len != 16)) {
				return false;
			}
		} else if (this.cardType == "AM") {
			prefix = parseInt(this.cardNumber.substring(0,2));
			if (((prefix != 34) && (prefix != 37)) || (len != 15)) {
				return false;
			}
		} else if (this.cardType == "DC") {
			prefix = parseInt(this.cardNumber.substring(0,4));
			if ((prefix != 6011) || (len < 13 || len > 19)) {
				return false;
			}
		}

		return this.luhnFormula(len);
	} else {
	  return false;
	}
}

/*
 * Checks the a credit card number is valid
 */
 PaymentFunctions.prototype.luhnFormula = function(len) {
	var start = (len-2);
	var total = 0;
	for(var i = start; i >= 0; i -= 2) {
		var num = this.cardNumber.charAt(i) * 2;
		if (num > 9) {
			var numString = num.toString();
			var nm1 = numString.charAt(0) * 1;
			var nm2 = numString.charAt(1) * 1;
			num = nm1 + nm2;
		}
		total += num;
	}
	for (i = (start+1); i >= 0; i -= 2) {
		var digVal = this.cardNumber.charAt(i) * 1;
		total += digVal;
	}

	return ((total % 10) == 0);
}

 /*
  * Retrieves the credit card type for a given credit card number
  */
PaymentFunctions.prototype.retrieveCCType = function() {
	if (this.verifyParameterType(this.cardNumber)) {
		var cardNumberLength = this.cardNumber.length;
		if (cardNumberLength == 16 || cardNumberLength == 13) {
		 	// it's either visa, mastercard, or discover
		 	if (this.cardNumber.charAt(0) == '4') {
		 		// it's a visa credit card
		 		this.cardType = 'VS';
		 		return this.cardType;
		 	} else {
		 		var prefix = this.cardNumber.substring(0, 2),
		 			e_prefix = this.cardNumber.substring(0, 4);
		 		if ((parseInt(prefix) > 50 && parseInt(prefix) < 56) || (parseInt(e_prefix) >= 2221 && parseInt(e_prefix) <= 2720)) {
		 			// it's a mastercard credit card
		 			this.cardType = 'MC';
		 			return this.cardType;
		 		} else {
		 			var prefix = this.cardNumber.substring(0, 4);
		 			if (parseInt(prefix) == 6011) {
		 				// it's a discover credit card
		 				this.cardType = 'DC';
		 				return this.cardType;
		 			}
		 		}
		 	}
		 } else if (cardNumberLength == 15) {
		 	var prefix = this.cardNumber.substring(0, 2);
		 	if (parseInt(prefix) == 34 || parseInt(prefix) == 37) {
		 		// it's an american express credit card
		 		this.cardType = 'AM';
		 		return this.cardType;
		 	}
		 } else {
		 	// it isn't a valid credit card or accepted method of payment
		 	return false;
		 }
	} else {
		return false;
	}
}